export default "/_next/static/images/BecomeMember-52f86f36a80518a1284e26596ea61f84.png";